export function formatCompact(value: number): string {
  if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
  return `${value}`;
}

export function pluralize(count: number, singular: string, plural?: string): string {
  if (count === 1) return singular;
  return plural ?? `${singular}s`;
}

const currencyPrefixes: Record<string, string> = {
  KES: 'KES ',
  TZS: 'TZS ',
  UGX: 'UGX ',
  USD: '$',
  EUR: '€',
};

export function formatMoney(amount: number, currency = 'KES'): string {
  const prefix = currencyPrefixes[currency] ?? `${currency} `;
  return `${prefix}${amount.toLocaleString()}`;
}

export function formatDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/** Timestamp label for ledger lines, e.g. "16 Sep 2026, 11:23". */
export function formatDateTime(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}